import { ShaderMaterial } from 'three';

import { materialEasyUniforms } from '@resn/gozer-three';

import {
    shaderChunks as ShaderChunksMatcap,
    uniforms as uniformsMatcap,
} from '../shaders/ShaderChunks/matcap';
import {
    shaderChunks as ShaderChunksRainbow,
    uniforms as uniformsRainbow,
} from '../shaders/ShaderChunks/rainbow';
import glslBlend from '@/libs/lygia/color/blend.glsl';
import glslSnoise from '@/libs/lygia/generative/snoise.glsl';
import glslRotate from '@/libs/lygia/space/rotate.glsl';

class SimpleIrridescentMaterial extends ShaderMaterial {
    constructor(props, options) {
        props = Object.assign(
            {
                vertexShader,
                fragmentShader,
                type: 'SimpleMatcapMaterial',
            },
            props
        );
        super(props);

        const uniforms = { ...uniformsMatcap(), ...uniformsRainbow() };
        this.uniforms = { ...uniforms, ...this.uniforms };
        materialEasyUniforms(this, this.uniforms);
    }
}
export default SimpleIrridescentMaterial;

const vertexShader = /* glsl */ `
    varying vec2 vUv;
    varying vec3 vViewPosition;
    varying vec3 vPosition;
    #include <normal_pars_vertex>
    void main() {
        #include <beginnormal_vertex>
        #include <begin_vertex>
        #include <defaultnormal_vertex>
        #include <normal_vertex>
        #include <project_vertex>
        
        gl_Position = projectionMatrix * mvPosition;
        vUv = uv;
        vViewPosition = - mvPosition.xyz;
        vPosition = vec3( position );
    }
`;
const fragmentShader = /* glsl */ `
    varying vec2 vUv;
    varying vec3 vViewPosition;
    varying vec3 vPosition;
    #include <normal_pars_fragment>
    
    ${glslSnoise}
    ${glslBlend}
    ${glslRotate}

    ${ShaderChunksMatcap.uniforms}
    ${ShaderChunksRainbow.uniforms}
    
    ${ShaderChunksRainbow.funcs}
    ${ShaderChunksMatcap.funcs}
    void main() {
    
        
        vec3 normal = vNormal;
        vec3 viewPosition = vViewPosition;
        vec3 viewDir = normalize(viewPosition);

        vec3 mvPosition = vViewPosition;
        mvPosition = rotate(mvPosition, u_matcapRotationWorld, vec3(0.0, 1.0, 0.0));
                
        vec4 color = vec4(vec3(0.0), 1.0);
        color.rgb = matcap(tMatcap, normal, mvPosition, false, 1.0, 1.0, color.a, u_matcapRotation);
        
        #if defined(USE_RAINBOW)
            vec3 cRainbow = rainbow(viewDir, normal, u_rwThickness, u_rwMovement, u_rwWavelengths, u_rwNoiseStrength, u_rwNoiseScale, u_rwOffset, false, 1.0, 1.0, accumAlpha);
            // color.rgb = blendMultiply(color.rgb, cRainbow, 1.);
            // color.rgb = blendOverlay(color.rgb, cRainbow, 1.);
            float m = 0.6;
            #if defined(USE_RAINBOW_MASK)
            m = texture2D(tRGB, vUv).r;
            #endif
            color.rgb = blendScreen(color.rgb, cRainbow, m);
        #endif        
        gl_FragColor = color;
    }
`;
